import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import SidebarNavAccordion from "../../../SidebarNavAccordion";

export const Modules_Teachers = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    // const { user } = useSelector((state) => state.auth);

    const canShowAccordion = hasPermission([
        "TEACHERS",
        "PAYROLL_TEACHERS_V2",
        "PAYROLL_TEACHERS_V1",
        "TEACHERS_READONLY",
        "MODULES_TEACHERS",
        "EAD_LIST",
        "EAD_READ_ONLY",
        "PAYROLL_JUSTIFY_REQUEST",
        "PAYROLL_JUSTIFY_REVIEW",
        "PAYROLL_JUSTIFY_APPROVE",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Teachers"));
        }
    }, [canShowAccordion]);

    return (
        // Los permisos que agregues en este nivel van a determinar cuando se renderiza el dropdown de control escolar
        <div>
            {canShowAccordion && (
                <SidebarNavAccordion
                    title={"Docentes"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-solid fa-solid fa-person-chalkboard fa-xl"
                >
                    {/* Si agregas un nuevo modulo aqui, con un permiso nuevo, asegurate que este en el elemento padre, aqui arribita ⬆️ */}

                    {hasPermission(["TEACHERS", "TEACHERS_READONLY"]) && (
                        <NavLinkApp
                            name="Docentes"
                            to="/app/teachers/list"
                            icon={
                                <IconApp iconClassName="fas fa-chalkboard-teacher c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission("PAYROLL_TEACHERS_V2") && (
                        <NavLinkApp
                            name="Nóminas docentes"
                            to="/app/teachers/v2/payroll/list"
                            icon={
                                <IconApp iconClassName="fas fa-file-invoice-dollar c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission([
                        "PAYROLL_JUSTIFY_REQUEST",
                        "PAYROLL_JUSTIFY_REVIEW",
                        "PAYROLL_JUSTIFY_APPROVE",
                    ]) && (
                        <NavLinkApp
                            name="Justificaciones"
                            to="/app/teachers/v2/justify/list"
                            icon={
                                <IconApp iconClassName="fas fa-file-invoice-dollar c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission("MODULES_TEACHERS") && (
                        <>
                            <NavLinkApp
                                name="Módulos Docentes"
                                to="/app/modules/teachers/list"
                                icon={
                                    <IconApp iconClassName="fas fa-chalkboard-teacher c-sidebar-nav-icon"></IconApp>
                                }
                            />
                            <NavLinkApp
                                name="Grupo de Docentes"
                                to="/app/modules/teachers/groups/list"
                                icon={
                                    <IconApp iconClassName="fas fa-users c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </>
                    )}

                    {hasPermission("PAYROLL_TEACHERS_V1") && (
                        <>
                            <NavLinkApp
                                name="Nóminas docentes v1"
                                to="/app/teachers/payrolls/list"
                                icon={
                                    <IconApp iconClassName="fas fa-file-invoice-dollar c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </>
                    )}

                    {hasPermission(["EAD_LIST", "EAD_READ_ONLY"]) && (
                        <div>
                            <NavLinkApp
                                name="EAD"
                                to="/app/ead/lista"
                                icon={
                                    <IconApp iconClassName="fas fa-school c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </div>
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
